import { jsxs, jsx } from 'react/jsx-runtime';
import 'react';

const YozmITSymbol = ({ className, variant })=>{
    if (variant === 'disabled') {
        return /*#__PURE__*/ jsxs("svg", {
            xmlns: "http://www.w3.org/2000/svg",
            width: "24",
            height: "24",
            viewBox: "0 0 24 24",
            fill: "none",
            className: className,
            "data-testid": "design-system-logo--yozmIT-symbol-disabled",
            children: [
                /*#__PURE__*/ jsx("path", {
                    fillRule: "evenodd",
                    clipRule: "evenodd",
                    d: "M7.87702 4C7.24578 4 6.66607 4.36093 6.36548 4.94107L1.08261 15.1667C1.02606 15.2753 0.997659 15.3971 1.00015 15.5204C1.00264 15.6437 1.03594 15.7642 1.09683 15.8703C1.15772 15.9764 1.24414 16.0645 1.34772 16.1261C1.4513 16.1877 1.56854 16.2206 1.68808 16.2218H9.69022L11.3327 13.042L8.81636 7.7964C8.79022 7.74206 8.77786 7.68178 8.78044 7.62118C8.78303 7.56058 8.80047 7.50164 8.83114 7.44989C8.86181 7.39813 8.90471 7.35524 8.95582 7.32522C9.00693 7.2952 9.06458 7.27905 9.1234 7.27825H11.0042C11.1322 7.27877 11.2575 7.31616 11.366 7.38619C11.4745 7.45622 11.5619 7.55611 11.6183 7.67461L12.8153 10.1712L15.4583 5.054C15.5152 4.94566 15.5439 4.82398 15.5417 4.70081C15.5395 4.57764 15.5064 4.45715 15.4457 4.35106C15.3849 4.24497 15.2986 4.15689 15.1951 4.09537C15.0916 4.03386 14.9745 4.001 14.855 4H7.87702Z",
                    fill: "#BDBDBD"
                }),
                /*#__PURE__*/ jsx("path", {
                    fillRule: "evenodd",
                    clipRule: "evenodd",
                    d: "M17.1396 7.27832L12.766 15.8421C12.7081 15.9561 12.6211 16.0518 12.5144 16.1187C12.4078 16.1856 12.2854 16.2212 12.1606 16.2218H9.69036L8.5406 18.4461C8.29476 18.9222 8.62648 19.5001 9.14607 19.5001H16.123C16.7542 19.5001 17.3339 19.1392 17.6334 18.559L22.9174 8.33343C22.9739 8.22488 23.0023 8.10313 22.9999 7.97995C22.9974 7.85677 22.9642 7.73633 22.9035 7.63025C22.8427 7.52417 22.7564 7.43605 22.653 7.3744C22.5496 7.31275 22.4325 7.27966 22.313 7.27832H17.1396Z",
                    fill: "#BDBDBD"
                })
            ]
        });
    }
    if (variant === 'bluegray') {
        return /*#__PURE__*/ jsxs("svg", {
            xmlns: "http://www.w3.org/2000/svg",
            width: "24",
            height: "24",
            viewBox: "0 0 24 24",
            fill: "none",
            className: className,
            "data-testid": "design-system-logo--yozmIT-symbol-bluegray",
            children: [
                /*#__PURE__*/ jsx("path", {
                    fillRule: "evenodd",
                    clipRule: "evenodd",
                    d: "M7.87702 4C7.24578 4 6.66607 4.36093 6.36548 4.94107L1.08261 15.1667C1.02606 15.2753 0.997659 15.3971 1.00015 15.5204C1.00264 15.6437 1.03594 15.7642 1.09683 15.8703C1.15772 15.9764 1.24414 16.0645 1.34772 16.1261C1.4513 16.1877 1.56854 16.2206 1.68808 16.2218H9.69022L11.3327 13.042L8.81636 7.7964C8.79022 7.74206 8.77786 7.68178 8.78044 7.62118C8.78303 7.56058 8.80047 7.50164 8.83114 7.44989C8.86181 7.39813 8.90471 7.35524 8.95582 7.32522C9.00693 7.2952 9.06458 7.27905 9.1234 7.27825H11.0042C11.1322 7.27877 11.2575 7.31616 11.366 7.38619C11.4745 7.45622 11.5619 7.55611 11.6183 7.67461L12.8153 10.1712L15.4583 5.054C15.5152 4.94566 15.5439 4.82398 15.5417 4.70081C15.5395 4.57764 15.5064 4.45715 15.4457 4.35106C15.3849 4.24497 15.2986 4.15689 15.1951 4.09537C15.0916 4.03386 14.9745 4.001 14.855 4H7.87702Z",
                    fill: "#787D85"
                }),
                /*#__PURE__*/ jsx("path", {
                    fillRule: "evenodd",
                    clipRule: "evenodd",
                    d: "M17.1396 7.27832L12.766 15.8421C12.7081 15.9561 12.6211 16.0518 12.5144 16.1187C12.4078 16.1856 12.2854 16.2212 12.1606 16.2218H9.69036L8.5406 18.4461C8.29476 18.9222 8.62648 19.5001 9.14607 19.5001H16.123C16.7542 19.5001 17.3339 19.1392 17.6334 18.559L22.9174 8.33343C22.9739 8.22488 23.0023 8.10313 22.9999 7.97995C22.9974 7.85677 22.9642 7.73633 22.9035 7.63025C22.8427 7.52417 22.7564 7.43605 22.653 7.3744C22.5496 7.31275 22.4325 7.27966 22.313 7.27832H17.1396Z",
                    fill: "#787D85"
                })
            ]
        });
    }
    return /*#__PURE__*/ jsxs("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: "24",
        height: "24",
        viewBox: "0 0 24 24",
        fill: "none",
        className: className,
        "data-testid": "design-system-logo--yozmIT-symbol",
        children: [
            /*#__PURE__*/ jsx("path", {
                fillRule: "evenodd",
                clipRule: "evenodd",
                d: "M7.87702 4C7.24578 4 6.66607 4.36093 6.36548 4.94107L1.08261 15.1667C1.02606 15.2753 0.997659 15.3971 1.00015 15.5204C1.00264 15.6437 1.03594 15.7642 1.09683 15.8703C1.15772 15.9764 1.24414 16.0645 1.34772 16.1261C1.4513 16.1877 1.56854 16.2206 1.68808 16.2218H9.69022L11.3327 13.042L8.81636 7.7964C8.79022 7.74206 8.77786 7.68178 8.78044 7.62118C8.78303 7.56058 8.80047 7.50164 8.83114 7.44989C8.86181 7.39813 8.90471 7.35524 8.95582 7.32522C9.00693 7.2952 9.06458 7.27905 9.1234 7.27825H11.0042C11.1322 7.27877 11.2575 7.31616 11.366 7.38619C11.4745 7.45622 11.5619 7.55611 11.6183 7.67461L12.8153 10.1712L15.4583 5.054C15.5152 4.94566 15.5439 4.82398 15.5417 4.70081C15.5395 4.57764 15.5064 4.45715 15.4457 4.35106C15.3849 4.24497 15.2986 4.15689 15.1951 4.09537C15.0916 4.03386 14.9745 4.001 14.855 4H7.87702Z",
                fill: "url(#paint0_linear_3475_577)"
            }),
            /*#__PURE__*/ jsx("path", {
                fillRule: "evenodd",
                clipRule: "evenodd",
                d: "M17.1396 7.27832L12.766 15.8421C12.7081 15.9561 12.6211 16.0518 12.5144 16.1187C12.4078 16.1856 12.2854 16.2212 12.1606 16.2218H9.69036L8.5406 18.4461C8.29476 18.9222 8.62648 19.5001 9.14607 19.5001H16.123C16.7542 19.5001 17.3339 19.1392 17.6334 18.559L22.9174 8.33343C22.9739 8.22488 23.0023 8.10313 22.9999 7.97995C22.9974 7.85677 22.9642 7.73633 22.9035 7.63025C22.8427 7.52417 22.7564 7.43605 22.653 7.3744C22.5496 7.31275 22.4325 7.27966 22.313 7.27832H17.1396Z",
                fill: "url(#paint1_linear_3475_577)"
            }),
            /*#__PURE__*/ jsxs("defs", {
                children: [
                    /*#__PURE__*/ jsxs("linearGradient", {
                        id: "paint0_linear_3475_577",
                        x1: "8.2709",
                        y1: "4",
                        x2: "8.2709",
                        y2: "16.2218",
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ jsx("stop", {
                                stopColor: "#8E2DE2"
                            }),
                            /*#__PURE__*/ jsx("stop", {
                                offset: "1",
                                stopColor: "#5A00DB"
                            })
                        ]
                    }),
                    /*#__PURE__*/ jsxs("linearGradient", {
                        id: "paint1_linear_3475_577",
                        x1: "15.7289",
                        y1: "7.27832",
                        x2: "15.7289",
                        y2: "19.5001",
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ jsx("stop", {
                                stopColor: "#8E2DE2"
                            }),
                            /*#__PURE__*/ jsx("stop", {
                                offset: "1",
                                stopColor: "#5A00DB"
                            })
                        ]
                    })
                ]
            })
        ]
    });
};

export { YozmITSymbol as default };
